import {
  IPlaylist,
  IPlaylistGroup,
  IPlaylistUserDetails,
  IPlaylistUserListItemResponse,
  IPlaylistsDataCtx,
  IPlaylistUsersSummary,
} from './types';

export const playlistsInitialValues: IPlaylistsDataCtx = {
  list: {
    items: null,
    loading: false,
    count: 0,
    error: 'false',
  },
  filters: {
    page: '1',
    page_size: '9',
    name: '',
    type: '',
    assigned: '',
    createdBy: 'allUsers',
  },
};

export const playlistInitialValues: IPlaylist = {
  id: undefined,
  name: '',
  color: '',
  is_account_playlist: false,
  has_active_deadlines: false,
};

export const playlistUsersInitialValues: IPlaylistUserListItemResponse = {
  user: {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    avatar: '',
  },
  last_activity_date: '',
  progress: 0,
  items_started: 0,
  items_finished: 0,
  items_total: 0,
  trackable_items_finished: 0,
  trackable_items_total: 0,
  deadline: null,
};

export const playlistUsersSummaryInitialValues: IPlaylistUsersSummary = {
  total_users: 0,
  is_account_playlist: false,
};

// Small helpers used by playlist pagination logic.
// API params can be strings/null; we normalize them once and reuse.
export const toPositiveNumber = (
  value: string | number | null | undefined,
  fallback: number
): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

// Given a full array, return only the items for the current page.
// Also return the indexes so callers can reuse them for fallback slicing.
export const getPageSlice = <T>(items: T[], page: number, pageSize: number) => {
  const startIndex = Math.max(0, (page - 1) * pageSize);
  const endIndex = startIndex + pageSize;
  return { slice: items.slice(startIndex, endIndex), startIndex, endIndex };
};

// Build a stable list of string IDs from any array (filters out empty IDs).
export const buildIdList = <T>(
  items: T[],
  getId: (item: T) => string | number | null | undefined
) =>
  items
    .map((item) => getId(item))
    .filter(Boolean)
    .map((id) => id!.toString());

// Compare two ID lists and ensure order is the same.
export const isSameIdList = (first: string[], current: string[]) =>
  first.length > 0 &&
  first.length === current.length &&
  first.every((id, index) => id === current[index]);
